import type { AppListenerEffectAPI, AppStartListening } from '@/redux/store';
import { PluginsEventBus } from '@/services/pluginsManager/pluginsEventBus';
import { Action, createListenerMiddleware } from '@reduxjs/toolkit';
import { openedDrawerSelector } from '../drawer.selectors';

export const panelEventsListenerMiddleware = createListenerMiddleware();

const startListening = panelEventsListenerMiddleware.startListening as AppStartListening;

/**
 * Derives onPanelOpen / onPanelClose from the change of the opened panel, so they are reported
 * whichever of the many drawer actions (or the plugin API) caused it, and after the state update
 * is finished - see pluginEvents.middleware.ts for why plugin callbacks must not run in a reducer.
 * A panel that stays open while showing other content (e.g. another bio entity) is not reported.
 */
export const panelEventsMiddlewareListener = async (
  action: Action,
  { getOriginalState, getState }: AppListenerEffectAPI,
): Promise<void> => {
  const previous = openedDrawerSelector(getOriginalState());
  const current = openedDrawerSelector(getState());

  if (previous === current) {
    return;
  }
  if (previous) {
    PluginsEventBus.dispatchEvent('onPanelClose', { name: previous });
  }
  if (current) {
    PluginsEventBus.dispatchEvent('onPanelOpen', { name: current });
  }
};

startListening({
  predicate: () => true,
  effect: panelEventsMiddlewareListener,
});
